<template>
    <div class="tpl">
        <el-date-picker
            v-model="condition.now_time"
            unlink-panels
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            style="vertical-align: middle;margin-top: -4px;width: 240px;"
            start-placeholder="开始日期"
            @change="conditionChange($event, 'now_time')"
            end-placeholder="结束日期"
        ></el-date-picker>

        <input
            type="text"
            class="name"
            style="width: 90px;"
            v-model="condition.vip_name"
            placeholder="会员姓名"
            @change="conditionChange($event, 'vip_name')"
        />
        <input
            type="text"
            class="name"
            style="width: 90px;"
            v-model="condition.cabeza_name"
            placeholder="家长姓名"
            @change="conditionChange($event, 'cabeza_name')"
        />
        <input
            type="number"
            min="0"
            class="name"
            style="width: 60px;"
            v-model="condition.yueling1"
            placeholder="月龄"
            @change="conditionChange($event, 'yueling1')"
        />至
        <input
            type="number"
            min="0"
            class="name"
            style="width: 60px;"
            v-model="condition.yueling2"
            placeholder="月龄"
            @change="conditionChange($event, 'yueling2')"
        />
        <input
            type="text"
            class="name"
            style="width: 120px;"
            maxlength="11"
            v-model="condition.cabeza_tel"
            placeholder="家长电话"
            @change="conditionChange($event, 'cabeza_tel')"
        />

        <select
            name
            class="select1 name"
            v-model="condition.selectVal"
            style="height: 38px;padding-left:10px;width: 104px;"
            @change="conditionChange($event, 'selectVal')"
        >
            <option value>状态</option>
            <option
                v-for="item in option1"
                :value="item.content"
                :key="item.content"
            >{{item.content}}</option>
        </select>

        <select
                name
                class="select1 name"
                v-model="condition.usertypeVal"
                style="height: 38px;padding-left:10px;width: 104px;"
                @change="conditionChange($event, 'usertypeVal')"
        >
            <option value>分类</option>
            <option
                    v-for="item in option_type"
                    :value="item.usertype"
                    :key="item.usertype"
            >{{item.usertype}}</option>
        </select>

        <select
            name
            class="select2 name"
            @change="conditionChange($event, 'select_Val');$emit('doSearch_2', '1, 2')"
            v-if="show_zj == 1"
            v-model="condition.select_Val"
            style="height: 38px;"
        >
            <option value>顾问</option>
            <option
                v-for="(item,index) in options"
                :value="item.user_id"
                :key="index"
            >{{ item.username }}</option>
        </select>

        <select
            name
            class="select3 name"
            v-model="condition.select3Val"
            style="height: 38px;padding-left:10px;"
            @change="conditionChange($event, 'select3Val')"
        >
            <option value >来源</option>
            <option v-for="item in option2" :value="item.label" :key="item.label">{{item.label}}</option>
        </select>
        <el-button type="warning" @click="$emit('doSearch', 1)" icon="el-icon-search"></el-button>
        <button class="refresh-btn" @click="clear_search">
            <i class="el-icon-refresh"></i>
        </button>
    </div>
</template>

<script>
export default {
    name: "",
    data() {
        return {
            option1: [],
            option_type: [],
            condition: {}
        };
    },
    props: [
        "now_time",
        "vip_name",
        "cabeza_name",
        "cabeza_tel",
        "selectVal",
        "usertypeVal",
        "select_Val",
        "select3Val",
        "yueling1",
        "yueling2",
        "option2",
        "show_zj",
        "options"
    ],
    created() {
        // 不能直接改变父组件传进来的值
        Object.keys(this._props).forEach(element => {
            this.$set(this.condition, element, this._props[element]);
        });

        let that = this;
        $.ajax({
            url: process.env.apiUrl + "saas/index/get_all_status",
            type: "post",
            data: {
                token: that.$cookies.get("token")
            },
            success: function(data, status) {
                that.option1 = data.data;
                that.option_type = data.data2;
                that.$emit('getStatus', data.data)
            },
            fail: function(err, status) {
                console.log(err);
            }
        });
    },
    methods: {
        conditionChange(e, key) {
            this.$emit("update:" + key, this.condition[key]);
        },
        //清空搜索条件
        clear_search() {
            this.condition.vip_name = "";
            this.condition.cabeza_name = "";
            this.condition.cabeza_tel = "";
            this.condition.selectVal = "";
            this.condition.usertypeVal = "";
            this.condition.select_Val = "";
            this.condition.select3Val = "";
            this.condition.now_time = "";
            this.condition.yueling1 = "";
            this.condition.yueling2 = "";
            this.$emit("clear_search", "");
        }
    }
};
</script>
<style scoped>
.tpl {
    display: inline-block;
}
.name {
    display: inline-block;
    height: 36px;
    padding-left: 16px;
    margin-left: 5px;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
}
.el-button {
    padding: 6px 14px;
    background-color: #E6BE8A;
    margin-left: 15px;
    margin-right: 6px;
    vertical-align: middle;
}
.refresh-btn {
    width: 43px;
    border: 1px solid #e4e7ed;
    line-height: 24px;
    background-color: white;
    border-radius: 2px;
    cursor: pointer;
    vertical-align: middle;
}
</style>
<style>
    .tpl .el-date-editor .el-range-separator {
        width: 10%;
    }
</style>



// WEBPACK FOOTER //
// src/components/genjinCondition.vue